import { analytics } from './segment-source-contributors';

/**
 * NOTE: This code is redundant to that of outlier-components/src/components/sessions/InteractionTracker.tsx
 * However, to reduce time spent on refactoring going to just copy this logic into legacy to use
 * legacy segment write key
 */

type SessionEventTypes =
  | 'user_inactive'
  | 'user_active'
  | 'user_login'
  | 'user_logout'
  | 'user_session_terminate';

type SessionEventPayload = {
  event_type: SessionEventTypes;
  session_id?: string;
  is_internal?: boolean;
};

export const logSessionUserInactive = (payload?: SessionEventPayload) => {
  const sessionPayload: SessionEventPayload = {
    event_type: 'user_inactive',
    ...payload,
  };
  void analytics.track('Session', sessionPayload);
};

export const logSessionUserActive = (payload?: SessionEventPayload) => {
  const sessionPayload: SessionEventPayload = {
    event_type: 'user_active',
    ...payload,
  };
  void analytics.track('Session', sessionPayload);
};

export const logSessionUserLogin = (payload?: SessionEventPayload) => {
  const sessionPayload: SessionEventPayload = {
    event_type: 'user_login',
    ...payload,
  };
  void analytics.track('Session', sessionPayload);
};

export const logSessionUserLogout = (payload?: SessionEventPayload) => {
  const sessionPayload: SessionEventPayload = {
    event_type: 'user_logout',
    ...payload,
  };
  void analytics.track('Session', sessionPayload);
};

export const logSessionTerminateEvent = (payload?: SessionEventPayload) => {
  const sessionPayload: SessionEventPayload = {
    event_type: 'user_session_terminate',
    ...payload,
  };
  void analytics.track('Session', sessionPayload);
};
